// src/App.jsx
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProductModal from "./components/ProductModal";


// Pages (Frontend)crome 
import Home from "./pages/Home";
import Collections from "./pages/Collections";
import AddProduct from "./pages/AddProduct";
import BestSeller from "./pages/BestSeller";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Cart from "./pages/Cart";
import Address from "./pages/Address";
import Summary from "./pages/Summary";
import Invoice from "./pages/Invoice";
import ProductDetail from "./pages/ProductDetail";
import MarkBestSellers from "./pages/MarkBestSellers";
import Orders from "./pages/Orders";
import Carriers from "./pages/Carriers";

// Admin Pages
import AdminLogin from "./Admin/AdminLogin";
import AdminDashboard from "./Admin/AdminDashboard";
import AdminProducts from "./Admin/AddProduct";
import ProtectedRoute from "./Admin/ProtectedRoute";
import AdminOrders from "./Admin/AdminOrders";
console.log("Navbar:", Navbar);
console.log("Footer:", Footer);
console.log("Home:", Home);
console.log("Collections:", Collections);
console.log("AdminOrders:", AdminOrders);
console.log("MarkBestSellers:", MarkBestSellers);
console.log("AdminLogin:", AdminLogin);
console.log("ProtectedRoute:", ProtectedRoute);
console.log("AdminDashboard:", AdminDashboard);
console.log("AdminProducts:", AdminProducts);
console.log("Carriers:", Carriers);
// ✅ Main App component
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

// ✅ Inner component that can use useLocation()
function AppContent() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const location = useLocation(); // dynamically detect route
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50">
      {/* ✅ Navbar hidden on admin pages */}
      {!isAdminRoute && <Navbar setSelectedProduct={setSelectedProduct} />}

      <main className="pt-24">
        <Routes>
          {/* ⭐ Public Routes */}
          <Route path="/" element={<Home />} />
          <Route
            path="/collections"
            element={<Collections setSelectedProduct={setSelectedProduct} />}
          />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/bestseller" element={<BestSeller />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* 👥 Auth Routes */}
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />

          {/* 🛒 Cart Routes */}
          <Route path="/cart" element={<Cart />} />
          <Route path="/address" element={<Address />} />
          <Route path="/summary" element={<Summary />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/orders" element={<Orders />} />

          {/* 👑 Admin Public Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/careers" element={<Carriers />} />

          {/* 👑 Admin Protected Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products"
            element={
              <ProtectedRoute>
                <AdminProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/mark-best-sellers"
            element={
              <ProtectedRoute>
                <MarkBestSellers />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>

      {/* ✅ Footer hidden on admin pages */}
      {!isAdminRoute && <Footer />}

      {/* 🪟 Global Product Modal */}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}
    </div>
  );
}

export default App;
